import { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { FieldErrors } from '../components/FieldErrors.jsx';
import { homePathForUser } from '../utils/roles.js';

export function RegisterPage() {
  const { user, booting, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState(/** @type {Record<string, string[]> | undefined} */ (undefined));
  const [submitting, setSubmitting] = useState(false);

  if (!booting && user) {
    return <Navigate to={homePathForUser(user)} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors(undefined);
    setSubmitting(true);
    try {
      const u = await register({
        name,
        company_name: companyName || undefined,
        email,
        password,
        password_confirmation: passwordConfirmation,
      });
      navigate(homePathForUser(u), { replace: true });
    } catch (err) {
      setError(err.message);
      setFieldErrors(err.body?.errors);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Create agency account</h1>
        <p className="muted">Register your IT agency to manage clients and projects</p>
        <form onSubmit={onSubmit} className="stack">
          <label className="field">
            <span>Your name</span>
            <input
              type="text"
              autoComplete="name"
              value={name}
              onChange={(ev) => setName(ev.target.value)}
              required
            />
          </label>
          <label className="field">
            <span>Company name</span>
            <input
              type="text"
              value={companyName}
              onChange={(ev) => setCompanyName(ev.target.value)}
              placeholder="Your agency"
            />
          </label>
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              required
            />
          </label>
          <label className="field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              required
            />
          </label>
          <label className="field">
            <span>Confirm password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={passwordConfirmation}
              onChange={(ev) => setPasswordConfirmation(ev.target.value)}
              required
            />
          </label>
          {error ? <p className="err">{error}</p> : null}
          <FieldErrors errors={fieldErrors} />
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Creating…' : 'Register'}
          </button>
        </form>
        <div className="auth-links">
          <Link to="/">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
